(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define("SpineWebGLPlugin", [], factory);
	else if(typeof exports === 'object')
		exports["SpineWebGLPlugin"] = factory();
	else
		root["SpineWebGLPlugin"] = factory();
})(window, function() {
return 